import { Navigate, useLocation } from 'react-router-dom';
import { adminAuth } from '../../services/adminAuth';

export default function AdminProtectedRoute({ children }) {
  const location = useLocation();
  if (!adminAuth.isAuthenticated()) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
